import { Inject, Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';

@Injectable({
  providedIn: 'root',
})
export class EoTreeDropdownService<T> {
  data$ = new BehaviorSubject<TreeNode<T>[] | null>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  init() {
    this.data$.next(null);
  }

  getData(url: string): Observable<TreeNode<T>[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.data$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<TreeNode<T>[]>(param);
  }
}
